import { HttpBackend, HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

export class AppEnvironment {
  environment!: string;
  version!: string;
}
export class AppConfiguration {
  api!: string;
  reporting!: string;
  straming!: string;
}

@Injectable({
  providedIn: "root",
})
export class EnvService extends AppConfiguration {
  public config!: AppConfiguration;
  public env!: string;
  public version!: string;

  constructor(private httpBackend: HttpBackend) {
    super();
  }

  public async loadConfigurationFiles() {
    const newHttpClient = new HttpClient(this.httpBackend);
    let data = await newHttpClient
      .get<AppEnvironment>("../assets/@config/env.json")
      .toPromise();
    this.env = data.environment;
    this.version = data.version;

    this.config = await newHttpClient
      .get<AppConfiguration>("../assets/@config/env." + this.env + ".json")
      .toPromise();
  }
}
